import api from './index';

const BASE = '/slot';

interface SlotDay {
    date: string;
}

export const getAllSlotDaysInMonthAndYear = async (dateFrom: string, dateTo: string): Promise<SlotDay[]> => {
    return api.get(`${BASE}/getAllSlotDaysInMonthAndYear`, { params: { dateFrom, dateTo } }).then((res) => res.data);
};

export const getAllSlotHoursInMonthAndYear = async (dateFrom: string, dateTo: string) => {
    return api.get(`${BASE}/getAllSlotHoursInMonthAndYear`, { params: { dateFrom, dateTo } }).then((res) => res.data);
};
